import React, { useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import { CLIENT_RATING_BUTTONS } from './ConstRatingBtns.js';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const TD_RATE_CLIENT_HELP = `
  <div>
    <p>This is an overall rating of the client’s experience during this Test-drive, using this particular access method setup. (One star being lowest, and five being highest / best.)      
    </p>
    <p>
    The feedback field allows you to enter any specific comments that the client might have. 
    This might include the reasons for their star rating, and what they liked and didn’t like about using this access method setup.   
    </p>  
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  activeTestDriveClientRating: PropTypes.string,
  activeTestDriveClientFeedback: PropTypes.string,
  onChangeActiveTestDriveClientRating: PropTypes.func.isRequired,
  onChangeActiveTestDriveClientFeedback: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  activeTestDriveClientRating: '',
  activeTestDriveClientFeedback: ''
};

//content sub-component with unique content for this page
function TestDriveRateClientContent(props) {
  const firstName = props.firstName;
  const activeTestDriveClientRating = props.activeTestDriveClientRating;
  const activeTestDriveClientFeedback = props.activeTestDriveClientFeedback;
  const onChangeActiveTestDriveClientRating = props.onChangeActiveTestDriveClientRating;
  const onChangeActiveTestDriveClientFeedback = props.onChangeActiveTestDriveClientFeedback;
  const ratingBtns = CLIENT_RATING_BUTTONS;
  
  return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>{firstName}'s rating:</legend>
        {ratingBtns.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value}
              value={btn.value}
              checked={activeTestDriveClientRating===btn.value}
              onChange={onChangeActiveTestDriveClientRating}
              name="client-rating"
              type="radio"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
            </Label>
          </FormGroup>
        )}
      </FormGroup>
      <FormGroup>
      <Label for="client-feedback" className="aa-bold-text">
            {firstName}'s feedback:
          </Label>
          <Input
            id="client-feedback"
            value= {activeTestDriveClientFeedback}
            onChange= {onChangeActiveTestDriveClientFeedback}
            name="client-feedback"
            type="textfield"
          />
      </FormGroup>
    </Form>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveRateClient(props) {
  const firstName = props.firstName;
  const activeTestDriveClientRating = props.activeTestDriveClientRating;
  const activeTestDriveClientFeedback = props.activeTestDriveClientFeedback;
  const onChangeActiveTestDriveClientRating = props.onChangeActiveTestDriveClientRating;
  const onChangeActiveTestDriveClientFeedback = props.onChangeActiveTestDriveClientFeedback;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;
  const dev = props.dev || {};

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-smile-o",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `From ${firstName}'s perspective, how did that Test-drive go?`,
    subTitle: '',
    learnMore: {linkText: "Learn More about client's rating for a Test-drive",
                title: "Client's Rating for a Test-drive",
                content: TD_RATE_CLIENT_HELP
                },
    nextRoute: "",
    sidebar: false
  }

  console.log("Rendering TestDriveRateClient, clientRating is: " + activeTestDriveClientRating);

  useEffect(() => {
    return () => {
      saveFormData();
    }
  }, [saveFormData])

  //there is no useEffect() method because we aren't saving anything here to global Sesion
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveRateClientContent 
          firstName={firstName}
          activeTestDriveClientRating={activeTestDriveClientRating}
          activeTestDriveClientFeedback={activeTestDriveClientFeedback}
          onChangeActiveTestDriveClientRating={onChangeActiveTestDriveClientRating}
          onChangeActiveTestDriveClientFeedback={onChangeActiveTestDriveClientFeedback}
        />
      }
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveRateClient.propTypes = propTypes;
TestDriveRateClient.defaultProps = defaultProps;

export default TestDriveRateClient;